import * as Types from '../../../graphql/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CoachingListCountQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type CoachingListCountQuery = { __typename?: 'Query' } & {
  coachingAccountLists: { __typename?: 'CoachingAccountListConnection' } & Pick<
    Types.CoachingAccountListConnection,
    'totalCount'
  >;
};

export const CoachingListCountDocument = gql`
  query CoachingListCount {
    coachingAccountLists(first: 1) {
      totalCount
    }
  }
`;

/**
 * __useCoachingListCountQuery__
 *
 * To run a query within a React component, call `useCoachingListCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useCoachingListCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCoachingListCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useCoachingListCountQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CoachingListCountQuery,
    CoachingListCountQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CoachingListCountQuery,
    CoachingListCountQueryVariables
  >(CoachingListCountDocument, options);
}
export function useCoachingListCountLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CoachingListCountQuery,
    CoachingListCountQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CoachingListCountQuery,
    CoachingListCountQueryVariables
  >(CoachingListCountDocument, options);
}
export type CoachingListCountQueryHookResult = ReturnType<
  typeof useCoachingListCountQuery
>;
export type CoachingListCountLazyQueryHookResult = ReturnType<
  typeof useCoachingListCountLazyQuery
>;
export type CoachingListCountQueryResult = Apollo.QueryResult<
  CoachingListCountQuery,
  CoachingListCountQueryVariables
>;
